import React, { useEffect, useState } from 'react'

import './index.css'

import {
  BrowserRouter as Router,
  Switch,
  Link,
  Route,
} from 'react-router-dom';

import {
  AppBar,
  Toolbar,
  Typography,
  useMediaQuery,
  Button
} from '@material-ui/core'


import Search from './pages/search'
import Add from './pages/add'

const App = props => {
  const matches = useMediaQuery('(min-width:760px)')
  const [isDark, setDark] = useState(true)
  useEffect(() => {
    if(localStorage.getItem('theme') === null){
      localStorage.setItem('theme', true)
    }
    const dark = localStorage.getItem('theme')
    setDark(dark === 'true' ? true : false)
    document.body.style.backgroundColor = dark === 'true' ? '#121212' : '#f5f8f7'
  },[])
  const changeTheme = () => {
    if(localStorage.getItem('theme') === 'true'){
      localStorage.setItem('theme',false)
    } else {
      localStorage.setItem('theme', true)
    }
    const dark = localStorage.getItem('theme')
    setDark(dark === 'true' ? true : false)
    document.body.style.backgroundColor = dark === 'true' ? '#121212' : '#f5f8f7'
  }
  return (
    <Router>
      <AppBar
        position="static"
        style={{background: isDark ? "rgba(255,255,255,0.1)" : "#22676D"  , display: 'block'}}
        elevation={0}
        >
        <Toolbar style={{

        }}>
          <Typography edge="start" variant={"h6"}>
            <Link to="/" style={{textDecoration:'none', color:'white'}}>
              Pdb
            </Link>
          </Typography>
          <div className="line" />
          <Typography style={{flexGrow:1}}>
            Baza pytań
          </Typography>
          <Button onClick={changeTheme} style={{background: "rgba(255,255,255,0.1)", marginRight:10}}>
            <Typography style={{color:'white'}}>
              Dark Mode
            </Typography>
            <span style={{
              marginLeft:5,
              height:'15px',
              width:'15px',
              backgroundColor: isDark ? 'green' : '#cc0000',
              borderRadius: '50%',
              display: 'inline-block'
            }}></span>
          </Button>
          <Link to="add" style={{textDecoration:'none'}}>     
            <Button style={{background: "rgba(255,255,255,0.1)"}}>
              <Typography style={{color:'white'}}>
                Dodaj
              </Typography>
            </Button>
          </Link>
            
        </Toolbar>
      </AppBar>
      <div style={{width: matches ? '55vw':'95vw', margin: '0 auto', height:'calc(100vh - 200px)', display:'flex', flexDirection:'column'}}>
        <Switch>
           <Route exact path="/add" render={(props) => <Add {...props} isDark={isDark} /> }/>
           <Route exact path="/" render={(props) => <Search {...props} isDark={isDark} /> }/>
        </Switch>
      </div>
    </Router>
  )
}

export default App;